module.exports = __webpack_public_path__ + "img/my-story-hotel-rossio.e1d1f4d2.jpg";